import { toggleNotification } from "app/notification/ducks/notificationModal";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

export const NotificationButton = ({onClick=f=>f})=>{
    const dispatch = useDispatch();
    const notificationCount = useSelector(state => state.notificationCount);

    const toggle = useCallback((e)=>{
        onClick(e);
        dispatch(toggleNotification());
    }, [dispatch, onClick]);

    return <button onClick={toggle}>알림<span className="num">{notificationCount.count || 0}</span></button>;
}